/**
 * Une inscription ANNULÉE sort l'équipe de la compétition.
 *
 * Même règle que côté serveur (`cloud-api/api/core/team_participation.py`) :
 * l'équipe reste en base — on ne détruit pas son historique — mais elle n'est
 * plus proposée nulle part, ni dans la liste des équipes à placer, ni comptée
 * dans le dimensionnement des heats. La déclarer ici plutôt que dans chaque
 * écran évite que les deux lectures divergent : la page Équipes la barre, le
 * rail d'assignation doit la retirer.
 */
export interface InscriptionLisible {
  status?: string | null;
}

export const estInscriptionAnnulee = (
  registration?: InscriptionLisible | null,
): boolean => registration?.status === 'cancelled';
